export default __webpack_public_path__ + "static/1Ptvg83HX_SGhgqk0QotYKNnBcif-a3d0733c15a560eadd9f43c6d13780c7.woff2";